import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = [
    "categoryTrendCardIcon",
    "cardCategoryTrend",
    "categoryTrendCardIconAnimation",
  ];

  connect() {
    this._setCategoryTrendsCookies();

    if (this._cardCategoryTrendEnable()) {
      this._showCardCategoryTrend();
    }
  }

  showCategoryTrend(e) {
    e.preventDefault();
    if (this._cardCategoryTrendEnable()) {
      this._hideCardCategoryTrend(e);
    } else {
      this._showCardCategoryTrend(e);
    }
  }

  _setCategoryTrendsCookies() {
    var cookie = Cookies.get("indexCategoryCardTrend");

    if (cookie === undefined) {
      Cookies.set("indexCategoryCardTrend", true, { path: "/" });
    }
  }

  _cardCategoryTrendEnable() {
    return Cookies.get("indexCategoryCardTrend") === "true";
  }

  _showCardCategoryTrend() {
    if (!this.hasCardCategoryTrendTarget) {
      return;
    }

    Cookies.set("indexCategoryCardTrend", true, { path: "/" });
    this.categoryTrendCardIconTargets.forEach((element) => {
      element.classList.remove("tw-bg-gray-200", "dark:tw-bg-opacity-12");
      element.classList.add("tw-bg-primary-600", "dark:tw-bg-primary-600");
    });
    this.categoryTrendCardIconAnimationTargets.forEach((element) => {
      element.classList.remove("tw-translate-x-0", "dark:tw-bg-opacity-12");
      element.classList.add("md:tw-translate-x-4");
      element.classList.add("tw-translate-x-5");
    });
    this.cardCategoryTrendTarget.classList.remove("tw-hidden");
    this.cardCategoryTrendTarget.classList.add("tw-block");
  }

  _hideCardCategoryTrend() {
    Cookies.set("indexCategoryCardTrend", false, { path: "/" });
    this.categoryTrendCardIconTargets.forEach((element) => {
      element.classList.remove("tw-bg-primary-600", "dark:tw-bg-primary-600");
      element.classList.add("tw-bg-gray-200", "dark:tw-bg-opacity-12");
    });
    this.categoryTrendCardIconAnimationTargets.forEach((element) => {
      element.classList.remove("md:tw-translate-x-4");
      element.classList.add("tw-translate-x-0", "dark:tw-bg-opacity-12");
      element.classList.remove("tw-translate-x-5");
    });
    this.cardCategoryTrendTarget.classList.remove("tw-block");
    this.cardCategoryTrendTarget.classList.add("tw-hidden");
  }
}
